import { useLocation, Link } from 'react-router-dom';
import { LayoutDashboard, Package, ChefHat, ShoppingCart, Menu } from 'lucide-react';

interface BottomNavProps {
  onMenuClick: () => void;
}

export default function BottomNav({ onMenuClick }: BottomNavProps) {
  const location = useLocation();

  const tabs = [
    { label: 'Inicio', icon: LayoutDashboard, path: '/dashboard' },
    { label: 'Recetas', icon: ChefHat, path: '/recipes' },
    { label: 'Ingredientes', icon: Package, path: '/ingredients' },
    { label: 'Pedidos', icon: ShoppingCart, path: '/orders' },
    { label: 'Más', icon: Menu, path: null }, // triggers sidebar
  ];

  const isActive = (path: string | null) => {
    if (!path) return false;
    if (path === '/dashboard') return location.pathname === '/dashboard';
    return location.pathname.startsWith(path);
  };

  return (
    <nav className="md:hidden fixed bottom-0 inset-x-0 z-40 bg-white border-t border-slate-200 pb-safe">
      <div className="flex items-center justify-around h-16">
        {tabs.map((tab) => {
          const active = isActive(tab.path);
          const Icon = tab.icon;

          if (tab.path === null) {
            return (
              <button
                key={tab.label}
                onClick={onMenuClick}
                className="flex flex-col items-center justify-center gap-0.5 flex-1 py-2 text-slate-400 active:text-slate-600 transition-colors"
              >
                <Icon className="w-5 h-5" />
                <span className="text-[10px] font-medium">{tab.label}</span>
              </button>
            );
          }

          return (
            <Link
              key={tab.label}
              to={tab.path}
              className={`flex flex-col items-center justify-center gap-0.5 flex-1 py-2 transition-colors ${
                active ? 'text-blue-600' : 'text-slate-400 active:text-slate-600'
              }`}
            >
              <Icon className={`w-5 h-5 ${active ? 'text-blue-600' : ''}`} />
              <span className="text-[10px] font-medium">{tab.label}</span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
}
